export function setUnidadesMedida(state, unidadesMedida) {
  Object.assign(state.unidades_medida, unidadesMedida);
}

export function setUnidadesMedidaCargadas(state, unidadesMedidaCargadas) {
  state.unidades_medida_cargadas = unidadesMedidaCargadas;
}
